import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AncestrySummaryFormDE = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['ancestry'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const ancestryMotherField = s.ancestry.fields.find(({ name }) => name === 'ancestryMother');
  const ancestryMotherLabel = translate(ancestryMotherField?.label);
  const ancestryMotherValue =
    translate(ancestryMotherField?.options?.find(({ value }) => value === getFieldValue('ancestryMother'))?.label) ||
    getFieldValue('ancestryMother');

  const ancestryFatherField = s.ancestry.fields.find(({ name }) => name === 'ancestryFather');
  const ancestryFatherLabel = translate(ancestryFatherField?.label);
  const ancestryFatherValue =
    translate(ancestryFatherField?.options?.find(({ value }) => value === getFieldValue('ancestryFather'))?.label) ||
    getFieldValue('ancestryFather');

  return (
    <div className="summary-card" data-cy={'summary-form-ancestry'}>
      <h2>{translate(s.dataSummary.titles?.ancestry)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{ancestryMotherLabel}</div>
        <div className={'value'}>
          {!editMode && ancestryMotherValue}
          {editMode && <EditDataField field={ancestryMotherField!} slideId={'ancestry'} />}
        </div>
        <div className={'label'}>{ancestryFatherLabel}</div>
        <div className={'value'}>
          {!editMode && ancestryFatherValue}
          {editMode && <EditDataField field={ancestryFatherField!} slideId={'ancestry'} />}
        </div>
      </div>
    </div>
  );
};
